import React, { useEffect, useState } from 'react'
import moment from 'moment'
import lodashGet from 'lodash.get'
import Spinner from '../presentation/spinner'
import './style.css'

const CustomerCheckinsReport = ({ id }) => {
    const [ data, setData ] = useState(null)
    const [ projects, setProjects ] = useState(null)
    const [ isLoading, setIsLoading ] = useState(true)

    useEffect(() => {
        loadCheckinsAggregation(id)
        loadProjectsFromServer(id)
    }, [])

    const loadProjectsFromServer = (accountId) => {
       fetch(`/service/${accountId}/projects`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then(response => {
            response.json().then(setProjects)
        }).catch(console.error);
    }

    const loadCheckinsAggregation = (accountId) => {
        fetch(`/service/${accountId}/checkinsReport`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('idToken')}`
            },
            credentials: 'same-origin'
        }).then(response => {
            response.json().then(results => {
                setData(results.aggregations)
                setIsLoading(false)
            }
        )}).catch(error => {
            console.error(error)
            alert('Something went wrong while generating the resport. Please contact daniel@bluedot.io')
        })
    }

    const renderProjectIdRow = (projectId, groupByMonth) => {
        return groupByMonth.map((month) => {
          const projectFound = month.group_by_projectId.buckets.find(project => project.key === projectId)
          if (projectFound) {
            const byOs = projectFound.group_by_os.buckets
            let androidCount = 0
            let iosCount = 0

            byOs.forEach(osObj => {
                if (osObj.key === "android") androidCount += osObj.doc_count
                if (osObj.key === "Android") androidCount += osObj.doc_count
                if (osObj.key === "iOS") iosCount += osObj.doc_count
                if (osObj.key === "iPhone OS") iosCount += osObj.doc_count
            })
       
            return (
              <td className="column center">
                <td className="center">{androidCount.toLocaleString()}</td>
                <td className="center">{iosCount.toLocaleString()}</td>
              </td>
            )
          }
          return <td className="column center">-</td>
        })
    }

    const groupedByMonth = lodashGet(data, 'group_by_date_range.buckets[0].group_by_accountId.filter_by_type_checkin.group_by_month.buckets', [])
    const monthsKeys = groupedByMonth && groupedByMonth.map(month => month.key_as_string)

    if (isLoading) {
        return (
            <div className="loading-screen">
                <Spinner size={60}/>
                <h4>We're generating the report.</h4>
                <h4>Won't take long.</h4>
            </div>
        )
    } 

    return (
        <div className="checkins-report-table">
            <label className="box-label">Entry Events (Check-in) by month</label>
            <div>
            <table>
                <thead>
                    <tr>
                        <th className="left">Project Name</th>
                        { monthsKeys && monthsKeys.map(key => (
                            <th key={key}>
                                <div className="center">{moment(key).format('MMM/YY')}</div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        { monthsKeys && monthsKeys.map((key) => (
                            <td key={key}>
                                <td className="center"><h5>Android</h5></td>
                                <td className="center"><h5>iOS</h5></td>
                            </td>
                        ))}
                    </tr>
                    { projects && projects.map(project =>  (
                        <tr key={project._id}>
                            <td className="left column" >{project.name}</td>
                            { renderProjectIdRow(project._id, groupedByMonth) }
                        </tr>
                        )
                    )}
                </tbody>
            </table>
            </div>
        </div>
    ) // return
} // CustomerCheckinsReport

export default CustomerCheckinsReport